module.exports = __webpack_public_path__ + "img/Dan_Towne.c40976d9.png";